import { render, staticRenderFns } from "./WagonInfoPanel.vue?vue&type=template&id=cd412524"
import script from "./WagonInfoPanel.vue?vue&type=script&lang=js"
export * from "./WagonInfoPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports